import { ModeToggle } from "@/components/mode-toggle";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { MailIcon } from "lucide-react";
import React from "react";
import { Helmet } from "react-helmet";
import { Highlighter } from '@/components/ui/highlighter';

export default function Resume() {
  return (
    <div className="container lg:max-w-xl mx-auto py-[70px] space-y-8">
      <Helmet>
        <title>Resume</title>
      </Helmet>
      <div className="flex items-start justify-between w-full gap-4">
        <div className="flex flex-col items-start justify-center gap-1">
          <h1 className="text-xl font-semibold">Dinivan Nendra</h1>
          <p className="text-sm">Freelancer Prototyper</p>
          <p className="text-sm font-light opacity-60">Ponorogo, Indonesia</p>
          <div className="flex flex-wrap gap-2 py-4">
            {/* <a href='https://x.com/dinivannendra' target='_blank' className='text-xs opacity-30 hover:opacity-100 transition-all duration-300 ease-in-out'>
              X
            </a> */}
            <a
              href="https://www.linkedin.com/in/dinivan-nendra-gunawan/"
              target="_blank"
              className="text-xs opacity-30 hover:opacity-100 transition-all duration-300 ease-in-out"
            >
              Linkedin
            </a>
            <a
              href="mailto:dinivannendragunawan@gmail.com"
              target="_blank"
              className="text-xs opacity-30 hover:opacity-100 transition-all duration-300 ease-in-out"
            >
              Email
            </a>
            <a
              href="https://github.com/unaivan22"
              target="_blank"
              className="text-xs opacity-30 hover:opacity-100 transition-all duration-300 ease-in-out"
            >
              Github
            </a>
            <a
              href="https://layers.to/dinivannendra"
              target="_blank"
              className="text-xs opacity-30 hover:opacity-100 transition-all duration-300 ease-in-out"
            >
              Layers
            </a>
            {/* <a href='https://read.cv/dinivannendra' target='_blank' className='text-xs opacity-30 hover:opacity-100 transition-all duration-300 ease-in-out'>
              Read CV
            </a> */}
          </div>
        </div>
        <img
          src="/unaascii-sm.webp"
          className="w-[120px] h-auto object-cover transition delay-150 duration-300 ease-in-out hover:-translate-y-1 hover:scale-110 hover:rotate-12"
        />
      </div>
      <div className="flex flex-col gap-2">
        <h1>About</h1>
        <p className="text-sm font-light opacity-60">
          Freelance digital designer who enjoys turning complex tech ideas into
          clean, intuitive user experiences. In my downtime, I like diving into
          design engineering, crafting UI components, and experimenting with
          fun, interactive elements.
        </p>
      </div>
      <div className="flex flex-col gap-2">
        <h1 className="pb-2">Work Experience (5)</h1>
        <div className="flex flex-col gap-2 mb-4 border-b border-dashed border-stone-200 dark:border-stone-900 pb-6">
          <p><Highlighter action="highlight" color="#FF9800" delay={500} c>BPPKAD Kab. Ponorogo</Highlighter></p>
          <p className="text-xs opacity-100">
            Pranata Komputer <Badge>Ponorogo, Indonesia</Badge>{" "}
          </p>
          <p className="text-xs opacity-50">2025 - Present</p>
          <p className="text-sm font-light opacity-60">
            Responsible for supporting asset management through the use of
            information technology. This includes managing and developing asset
            information systems, validating and reconciling asset data,
            preparing asset reports using digital tools, and digitizing
            asset-related documents. The role also involves ensuring data
            security, performing regular backups, providing technical training
            to asset managers in local government agencies (OPDs), and
            supporting audit and asset monitoring processes to promote
            transparency and accountability in regional financial management.
          </p>
        </div>

        <div className="flex flex-col gap-2 mb-4 border-b border-dashed border-stone-200 dark:border-stone-900 pb-6">
          <p><Highlighter action="underline" color="#FF9800" delay={1000}><p className='text-black dark:text-white'>UIX Designer & UI Engineer</p></Highlighter></p>
          <p className="text-xs opacity-100">
            Freelancer <Badge>World</Badge>
          </p>
          <p className="text-xs opacity-50">2021 - Present</p>
          <p className="text-sm font-light opacity-60">
            Helped clients from various industries create engaging and intuitive
            digital experiences. I have expertise in understanding user needs,
            identifying problems, and delivering efficient and stunning design
            solutions and convert to code.
          </p>
        </div>

        <div className="flex flex-col gap-2 mb-4 border-b border-dashed border-stone-200 dark:border-stone-900 pb-6">
          <p><Highlighter action="underline" color="#FF9800" delay={2000}><p className='text-black dark:text-white'>Energeek</p></Highlighter></p>
          <p className="text-xs opacity-70">
            Sr. UI/UX Designer <Badge>Surabaya, Indonesia</Badge>
          </p>
          <p className="text-xs opacity-50">2024 - 2025</p>
          <p className="text-sm font-light opacity-60">
            Responsible for application design, both web and mobile. This
            involves defining workflows and key product features, as well as
            creating wireframes, prototypes, design systems, and transitions for
            easy-to-use user experiences. Also leads junior ui/ux designers
          </p>
        </div>

        <div className="flex flex-col gap-2 pl-8 mb-4 border-b border-dashed border-stone-200 dark:border-stone-900 pb-6">
          {/* <h5 className='text-md'>Energeek</h5> */}
          <p className="text-xs opacity-70">UI/UX Designer</p>
          <p className="text-xs opacity-50">2019 - 2024</p>
          <p className="text-sm font-light opacity-60">
            Responsible for application design, both web and mobile. This
            involves defining workflows and key product features, as well as
            creating wireframes, prototypes, design systems, and transitions for
            easy-to-use user experiences
          </p>
        </div>

        <div className="flex flex-col gap-2 mb-4 border-b border-dashed border-stone-200 dark:border-stone-900 pb-6">
          <p><Highlighter action="underline" color="#FF9800" delay={3000}><p className='text-black dark:text-white'>Advertising</p></Highlighter></p>
          <p className="text-xs opacity-70">
            Digital Marketer <Badge>Canada</Badge>
          </p>
          <p className="text-xs opacity-50">2018 – 2021</p>
          <p className="text-sm font-light opacity-60">Get more traffic.</p>
        </div>

        <div className="flex flex-col gap-2 mb-4 border-b border-dashed border-stone-200 dark:border-stone-900 pb-6">
          <p><Highlighter action="underline" color="#FF9800" delay={4000}><p className='text-black dark:text-white'>Central Ban</p></Highlighter></p>
          <p className="text-xs opacity-70">
            Service Advisor <Badge>Madiun, Indonesia</Badge>{" "}
          </p>
          <p className="text-xs opacity-50">2018 - 2019</p>
          <p className="text-sm font-light opacity-60">
            Listen and analyze user complaints related to car wheels, and
            provide the best solution in the selection and use of wheels and
            tires.
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <h1>Education</h1>
        <p className="text-sm font-light opacity-60">
          Diploma of Informatics. 2014 - 2018 Politeknik Elektronika Negeri
          Surabaya.
        </p>
      </div>
      <div className="flex flex-col gap-2">
        <h1>Skills</h1>
        <div className="flex flex-wrap gap-1">
          <Badge variant="outline" className="underline">
            Sitemap
          </Badge>
          <Badge variant="outline" className="underline">
            Wireframing
          </Badge>
          <Badge variant="outline" className="underline">
            Prototyping
          </Badge>
          <Badge variant="outline" className="underline">
            A/B Testing
          </Badge>
          <Badge variant="outline" className="underline">
            Usability Testing
          </Badge>
          <Badge variant="outline" className="underline">
            Team Work
          </Badge>
          <Badge variant="outline" className="underline">
            Problem Solving
          </Badge>
          <Badge variant="outline" className="underline">
            Time Management
          </Badge>
          <Badge variant="outline" className="underline">
            Organize
          </Badge>
          <Badge variant="outline" className="underline">
            Adaptation
          </Badge>
          <Badge variant="outline" className="underline">
            Leading
          </Badge>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <h1>Tools</h1>
        <div className="flex flex-wrap gap-1">
          <Badge variant="outline" className="underline">
            Figma
          </Badge>
          <Badge variant="outline" className="underline">
            Adobe Photoshop
          </Badge>
          <Badge variant="outline" className="underline">
            Adobe Illustrator
          </Badge>
          <Badge variant="outline" className="underline">
            HTML & CSS
          </Badge>
          <Badge variant="outline" className="underline">
            Javascript
          </Badge>
          <Badge variant="outline" className="underline">
            Reactjs (Vite)
          </Badge>
          <Badge variant="outline" className="underline">
            SwiftUI
          </Badge>
          <Badge variant="outline" className="underline">
            Diagrams
          </Badge>
          <Badge variant="outline" className="underline">
            Asana/Trello
          </Badge>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <h1>Hobbies</h1>
        <div className="flex flex-wrap gap-1">
          <Badge variant="outline" className="underline">
            Digital Prototyping
          </Badge>
          <Badge variant="outline" className="underline">
            Swimming
          </Badge>
        </div>
      </div>
      <div className="fixed right-12 bottom-12">
        <ModeToggle />
      </div>
    </div>
  );
}
